<script>
  import { createEventDispatcher } from "svelte"
  import AuthInput from "./authInput.svelte"
  import notify from "../Script/notify"

  const dispatch = createEventDispatcher()

  let code = ""
  let revokeReason = ""
  let hideRevokedDoc = false
  let showRevokeOptions = true

  const maxCharacters = 120

  let notification = {
    close() {},
  }

  /**
   * Allows:
   * A-Z a-z 0-9
   * space
   * - ( ) + & .
   */
  const sanitizeReason = (value) => {
    return value.replace(/[^A-Za-z0-9\s\-()+&.]/g, "")
  }

  const handleReasonInput = (e) => {
    notification.close()

    const originalValue = e.target.value

    let sanitizedValue = sanitizeReason(originalValue)

    if (originalValue !== sanitizedValue) {
      notification = notify.danger("Only letters, numbers, spaces and special characters -()+&. are allowed.")
    }

    if (sanitizedValue.length > maxCharacters) {
      notification = notify.info(`Cannot enter more than ${maxCharacters} characters`)

      revokeReason = sanitizedValue.trim()

      setTimeout(() => {
        revokeReason = revokeReason.slice(0, maxCharacters)
      }, 150)

      return
    }

    revokeReason = sanitizedValue
  }
</script>

<div class="fixed inset-0 -top-3 z-50 mt-0 flex flex-col items-center justify-center gap-3 overflow-hidden bg-[#000000cc] backdrop-blur-md">
  <div class="relative m-6 transform select-none rounded-md bg-white text-left transition-all dark:bg-bodyblack md:m-0 md:w-[700px]">
    <div class="flex w-full items-center justify-center rounded-md bg-white p-3 pb-0 text-black dark:bg-bodyblack md:px-6 md:pt-6">
      <h1 class="select-none text-xl font-bold text-black dark:text-white lg:text-2xl xl:text-2xl">Revoke Confirmation</h1>
    </div>

    {#if showRevokeOptions}
      <div class="w-full space-y-3 p-3 md:p-6">
        <div class="w-full space-y-2">
          <div class="w-full text-base font-medium text-gray-500">
            Do you want to show <strong>Revoked Document</strong>
            or not ?
          </div>
          <div class="mt-3 flex h-[37.6px] w-full gap-3 mobile:mt-0">
            <div class="flex items-center gap-3">
              <input bind:group={hideRevokedDoc} type="radio" id="showDoc" class="h-5 w-5 cursor-pointer" name="hideRevokedDoc" value={false} />
              <label for="showDoc" class="cursor-pointer text-base font-semibold text-gray-800 dark:text-gray-100">Show Document</label>
            </div>
            <div class="flex items-center gap-3">
              <input bind:group={hideRevokedDoc} id="hideDoc" class="h-5 w-5 cursor-pointer disabled:cursor-not-allowed" type="radio" name="hideRevokedDoc" value={true} />
              <label for="hideDoc" class="cursor-pointer text-base font-semibold text-gray-800 dark:text-gray-100">Hide Document</label>
            </div>
          </div>
        </div>

        <div class="space-y-2">
          <p class="block w-full select-none text-base font-medium text-gray-500">Reason for Revocation</p>

          <textarea
            placeholder="Enter reason (Optional)"
            bind:value={revokeReason}
            on:input={handleReasonInput}
            on:blur={() => {
              revokeReason = revokeReason.trim()
            }}
            name="reason"
            class="block max-h-[200px] min-h-[80px] w-full resize-none appearance-none rounded-md border border-[#a0a1a580] bg-transparent px-3 py-2 pl-5 text-sm text-gray-800 placeholder-gray-200 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 dark:text-white"
          />
        </div>

        <div class="!mt-6 flex w-full select-none justify-center gap-3">
          <button
            on:click={() => {
              dispatch("close")
            }}
            type="button"
            class="flex h-9 min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-red-500 px-2 text-sm font-medium text-white hover:bg-red-600 hover:text-white focus:outline-none active:bg-red-500 lg:px-4"
          >
            <i class="fa-solid fa-circle-xmark" />
            &nbsp;&nbsp;Cancel&nbsp;
          </button>

          <button
            on:click={() => {
              showRevokeOptions = false
            }}
            type="submit"
            class="flex h-9 min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-blue-500 px-2 text-sm font-medium text-white hover:bg-blue-600 hover:text-white focus:outline-none active:bg-blue-500 lg:px-4"
          >
            <i class="fa-solid fa-forward" />
            &nbsp;&nbsp;Continue&nbsp;
          </button>
        </div>
      </div>
    {:else}
      <div class="p-3">
        <AuthInput
          bind:code
          on:submit={() => {
            dispatch("submit", { code, hideRevokedDoc, revokeReason })
          }}
          cancelBtn={true}
          on:click={() => {
            dispatch("close")
          }}
          title="Please enter an Authentication Code from the linked Authenticator App to confirm the revokation of the document. Ensure you intend to revoke the document, as this action is irreversible."
        />
      </div>
    {/if}
  </div>
</div>
